module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.confirm_basket) ? _c('div', [((!_vm.checkout || (_vm.checkout && !_vm.$root.authenticated)) && (_vm.page == 'auth.register' || _vm.page == 'auth.login' || _vm.page == 'cart.details.confirm')) ? _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "alerts",
    attrs: {
      "id": "signup-alert"
    }
  }, [_c('span', {
    staticClass: "content"
  }, [_vm._v("\n                    " + _vm._s(_vm.locale.text_info_sign_up_description) + "\n                ")]), _vm._v(" "), (_vm.page == 'auth.login') ? _c('a', {
    staticClass: "cta-button red",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'auth.register',
          query: {
            back_route: (_vm.$route.query.hasOwnProperty('back_route') ? _vm.$route.query.back_route : _vm.$route.name)
          }
        })
      }
    }
  }, [_vm._v("Sign up")]) : _c('a', {
    staticClass: "cta-button blue",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'auth.login',
          query: {
            back_route: (_vm.$route.query.hasOwnProperty('back_route') ? _vm.$route.query.back_route : _vm.$route.name)
          }
        })
      }
    }
  }, [_vm._v("Sign in")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-layout-inner"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.page == 'auth.login') ? _c('login-form', {
    on: {
      "authenticated": _vm.authenticated
    }
  }) : (_vm.page == 'auth.password') ? _c('password-form') : (_vm.page == 'auth.reset') ? _c('reset-form') : _c('register-form', {
    on: {
      "registered": _vm.authenticated
    }
  })], 1)], 1)])])]) : _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-layout-inner"
  }, [_c('div', {
    staticClass: "title-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(_vm._s(_vm.locale.text_alert_decision_title))])])])]), _vm._v(" "), _vm._l((_vm.bookings), function(booking, key) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
    }, [_c('div', {
      staticClass: "box-layout-inner booking-choice"
    }, [_c('div', {
      staticClass: "title-block-alt"
    }, [_c('div', {
      staticClass: "alt-container"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s('Basket created ' + booking.booking_date.toDate().toDateString(true))
      }
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.currencyFormat(booking.total_cost, true)))])])]), _vm._v(" "), _c('div', {
      staticClass: "content-block"
    }, [_c('span', {
      staticClass: "participant-list"
    }, _vm._l((booking.collection), function(venue) {
      return _c('p', [_vm._v("\n                            " + _vm._s(venue.venue_name) + "\n                            "), _c('ul', {
        staticClass: "date-list"
      }, _vm._l((venue.items), function(item) {
        return _c('li', [_c('span', {
          domProps: {
            "innerHTML": _vm._s((new Date()).formatRange(item.days_attending) + '<br /><b>' + item.participant_full_name + '</b>')
          }
        })])
      }))])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "full-width-cta"
    }, [_c('a', {
      staticClass: "cta-button",
      class: {
        'blue': booking.user_id != null, 'red': booking.user_id == null
      },
      domProps: {
        "innerHTML": _vm._s((booking.user_id != null ? 'Continue with old basket' : 'Continue with current basket'))
      },
      on: {
        "click": function($event) {
          _vm.confirm(booking.user_id == null ? true : false)
        }
      }
    }), _vm._v(" "), (booking.hasOwnProperty('is_editing') && booking.is_editing == true) ? _c('p', [_vm._v(_vm._s(_vm.locale.text_alert_decision_edit_warning))]) : _vm._e()])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-109a5aca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/auth.vue
// module id = 156
// module chunks = 0